import React from 'react';

import {
    Container,
    Box,
    Stack,
    Tabs,
    Tab,
    Typography,
    IconButton,
} from '@mui/material';

import {ConfigContext} from '../Config/ConfigContext';
import FormInput from '../form/form-input';
import http from '../utils/http';
import useForm from '../hooks/useForm';

import { useParams } from 'react-router-dom';
import { debounce, kebabCase, } from 'lodash';
import { Add, Padding } from '@mui/icons-material';
import EnvironmentAddModal from './environmentAddModal';
import Environment from './environmentDetail';

const onLoad = async ({
    values,
}) => {
    const application = await http.get({}, `${values.config.uri.base}/application/${values.applicationId}`);
    const environments = await http.get({
        applicationId: values.applicationId
    }, `${values.config.uri.base}/environment`);
    return {
        ...values,
        appId: application.appId,
        name: application.name,
        environments: environments.rows
    };
};

function TabPanel(props) {
    const {
        children,
        value,
        index,
        ...other
    } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

const saveField = debounce(async (data, uri) => {
    await http.put(data, uri);
}, 500);

export default function ApplicationDetail() {
    const { config } = React.useContext(ConfigContext);
    const [value, setValue] = React.useState(0);
    const { applicationId } = useParams();
    const handleChange = (_, newValue) => {
        setValue(newValue);
    };

    const {
        state,
        onChange,
        onChangeBulk,
        onInvalidForm,
    } = useForm({
        debug: true,
        initialState: {
            applicationId: applicationId,
            name: '',
            appId: '',
            application: {},
            environments: [],
            config,
            environmentAddModalIsOpen: false,
            environmentDeleteModalIsOpen: false,
            applicationURIAddModalIsOpen: false,
            applicationURIDeleteModalIsOpen: false,
            acceptedDomainAddModalIsOpen: false,
            acceptedDomainDeleteModalIsOpen: false,
        },
        onLoad
    });

    return (
        <Container className='bg-white'>
            <EnvironmentAddModal
                onChange={onChange}
                onChangeBulk={onChangeBulk}
                onInvalidForm={onInvalidForm}
                config={config}
                isOpen={state.values.environmentAddModalIsOpen}
                applicationId={applicationId}
            />

            <Typography variant="h5" component={'div'}>Application Settings</Typography>
            <Box>
                <Stack gap={2} direction={'row'} justifyContent={'left'} flexWrap={'wrap'}>
                    <FormInput
                        label='Application Name'
                        path={'name'}
                        value={state.values.name}
                        onChange={(value, path) => {
                            onChange(kebabCase(value), 'appId');
                            onChange(value, path);
                            saveField({ [path]: value }, `${config.uri.base}/application/${applicationId}`)
                        }}
                    />
                    <FormInput
                        label='App Id'
                        path={'appId'}
                        value={state.values.appId}
                        onChange={(value, path) => {
                            onChange(value, path);
                            saveField({ [path]: value }, `${config.uri.base}/application/${applicationId}`)
                        }}
                    />
                </Stack>
            </Box>

            <Tabs
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="scrollable auto tabs example"
            >
                {state.values.environments.map((environment, index) => {
                    return (
                        <Tab key={index} label={environment.name} />
                    );
                })}
                <IconButton
                    key={state.values.environments.length + 1}
                    onClick={() => { onChange(!state.values.addEnvironmentModalIsOpen, 'environmentAddModalIsOpen') }}>
                    <Add />
                </IconButton>
            </Tabs>
            {state.values.environments.map((environment, environmentIndex) => {
                return (
                    <TabPanel key={environmentIndex} value={value} index={environmentIndex}>
                        <Environment
                            environmentId={environment._id}
                        />
                    </TabPanel>
                );
            })}
        </Container>
    );
}
